import React from 'react';
import './css/index.scss';
import Modal from 'react-modal';

function MyModal({
  isOpen, closeFunction, children, style, closeOnPressOutside = true,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeOnPressOutside ? closeFunction : undefined}
      style={{ overlay: styles.overlay, content: { ...styles.content, ...style } }}
      closeTimeoutMS={200}
    >
      {children}
    </Modal>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
  },
  content: {
    position: 'absolute',
    height: 'fit-content',
    width: 'fit-content',
    background: '#fff',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '12px',
    padding: '20px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
};

export default MyModal;
